module.exports = __webpack_public_path__ + "static/media/girl.a8ccae7c.jpg";